// @ai-generated 2026-08-27T08.12.58+00.00 by malte.ulfers@tngtech.com using Claude Opus 5 (1M context)
import type { ReactToolCallRenderer } from '@copilotkit/react-core/v2';
import { ToolCallCardShell } from './ToolCallCardShell';
import { resolveToolCallState } from './toolCallStatus';

/** Tools whose payload is not worth a table in a conversation: they get a title and nothing else. */
const PLAIN_TOOLS: { name: string; title: string }[] = [
    { name: 'emails.send_invoice.v1', title: 'Rechnung per E-Mail versandt' },
    { name: 'validation.get_for_orders.v1', title: 'Verfügbare Auftrags-Prüfkriterien abgefragt' },
    { name: 'validation.get_for_addresses.v1', title: 'Verfügbare Adress-Prüfkriterien abgefragt' },
];

function PlainToolCallCard({ title, result, status }: { title: string; result: unknown; status: unknown }) {
    return <ToolCallCardShell title={title} state={resolveToolCallState(status, result)} result={result} />;
}

/** Spread before the wildcard fallback, like the other specialized cards. */
export const ChatPlainToolCallCards: ReactToolCallRenderer[] = PLAIN_TOOLS.map((tool) => ({
    name: tool.name,
    render: ({ result, status }) => <PlainToolCallCard title={tool.title} result={result} status={status} />,
}));
